import { render } from "./VxFloatingInput.vue?vue&type=template&id=12dd3138&scoped=true"
import script from "./VxFloatingInput.vue?vue&type=script&lang=js"
export * from "./VxFloatingInput.vue?vue&type=script&lang=js"

import "./VxFloatingInput.vue?vue&type=style&index=0&id=12dd3138&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd3138"]])

export default __exports__